import { Box } from '@mui/material';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { SubTaskType } from '../../client/generated/graphql';
import { useFeatureFlag } from '../../contexts/FeatureFlagContext';
import { CommonIcon } from './CommonIcon';
import { CustomSelect } from './CustomSelect';

export type TaskTypeSelectProps = {
    taskType: SubTaskType;
    setTaskType: (taskType: SubTaskType) => void;
}

const getTaskTypeOptions = (ratingsEnabled: boolean, t: TFunction) => {
    const options = [
        { id: SubTaskType.Checkbox, label: t('ritual.taskTypes.checkbox') },
        { id: SubTaskType.Journal, label: t('ritual.taskTypes.journal') },
    ];
    if (ratingsEnabled) {
        options.push({ id: SubTaskType.Rating, label: t('ritual.taskTypes.rating') });
    }
    return options;
};

const getTaskTypeIcon = (taskType: SubTaskType): string => {
    switch (taskType) {
        case SubTaskType.Journal:
            return 'description';
        case SubTaskType.Rating:
            return 'star_outline';
        default:
            return 'check_box';
    }
};

export const TaskTypeSelect = (props: TaskTypeSelectProps) => {
    const { t } = useTranslation();
    const ratingsEnabled = useFeatureFlag('ratings');
    const taskTypeOptions = getTaskTypeOptions(ratingsEnabled, t);
    
    return (
        <CustomSelect
            selectedId={props.taskType}
            setSelectedId={(id) => props.setTaskType(id as SubTaskType)}
            options={taskTypeOptions}
            before={(t) => (
                <Box sx={{
                    width: 20,
                    height: 20,
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <CommonIcon
                        icon={getTaskTypeIcon(t.id)}
                        type="outlined"
                        size={14}
                        color="var(--tg-theme-text-color)"
                    />
                </Box>
            )}
            text={(t) => t.label}
            renderSelected={(option) => option ? option.label : t('ritual.taskType')}
            renderSelectedBefore={(t) => t ? (
                <Box sx={{
                    width: 20,
                    height: 20,
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <CommonIcon
                        icon={getTaskTypeIcon(t.id)}
                        type="outlined"
                        size={14}
                        color="var(--tg-theme-text-color)"
                    />
                </Box>
            ) : <></>}
        />
    );
};
